import { configResponsive } from 'ahooks/es/useResponsive';

configResponsive({
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  fhd: 1920,
  qhd: 2560,
});

export { default as CardLayout } from './CardLayout.tsx';
export { default as DealersLayout } from './DealersLayout.tsx';
export { default as ExploreLayout } from './ExploreLayout.tsx';
export { default as FullLayout } from './FullLayout.tsx';
export { default as MapLayout } from './MapLayout.tsx';
export { default as NoLayout } from './NoLayout.tsx';
export { default as RegisterLayout } from './RegisterLayout.tsx';
